import { api } from "./configs/axiosConfigs"

export const ImportAPI = {

    get: async (data?:any) => {
        const response = await api.get(
            '/import', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    update: async (id: number, data: any) => {
        const response = await api.post(
            `/import/update/${id}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    download: async (id:number) => {
        const response = await api.get(
            `/import/download/${id}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

}